/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APIFileTypeEnum {
    _3d_model = '3d_model',
    technical_drawing = 'technical_drawing'
}


export function instanceOfAPIFileTypeEnum(value: any): boolean {
    for (const key in APIFileTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(APIFileTypeEnum, key)) {
            if (APIFileTypeEnum[key as keyof typeof APIFileTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APIFileTypeEnumFromJSON(json: any): APIFileTypeEnum {
    return APIFileTypeEnumFromJSONTyped(json, false);
}

export function APIFileTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIFileTypeEnum {
    return json as APIFileTypeEnum;
}

export function APIFileTypeEnumToJSON(value?: APIFileTypeEnum | null): any {
    return value as any;
}

